<template>
	<div class="container">
		<triangle-image
			title="Scopri tante idee e ricette per il forno a vapore"
		/>

		<div >
			<div class="content">
				<section class="paragraph">
					<h2>
						Come cucinare con il forno a vapore
					</h2>

					<p>
						Se sei già in possesso o stai pensando di passare ad un <b>forno a vapore</b>, in questa pagina cercheremo di elencare tutti i vantaggi e le potenzialità della cucina con questo elettrodomestico. Prima di tutto, <b>cucinare con un forno a vapore è semplicissimo</b>. In base al modello in tuo possesso è sufficiente seguire tre passi: versare l’acqua nell’apposito serbatoio, selezionare la percentuale di vapore e impostare la temperatura adatta alla ricetta. 
						<br>
						Alcuni modelli hanno inoltre dei programmi preimpostati in base al tipo di ingredienti o pietanza che si deve preparare, per ottenere un risultato praticamente garantito. Facile no?

					</p>

					<h2>
						I vantaggi del forno a vapore
					</h2>

					<p>
						Ma quali sono i vantaggi nel cucinare con un forno a vapore rispetto ad un forno statico o ventilato? Prima di tutto la <b>cottura a vapore è tra le più salutari</b> perché aiuta a limitare la dispersione di nutrienti (ad esempio la vitamina B e l’acido folico contenuto nelle verdure). 
						<br>
						Lo stesso discorso vale anche per pesce e carne, che quando cucinati in forno con l’aggiunta di vapore manterranno tutti i minerali e le vitamine e soprattutto il loro sapore vero e originale, senza corruzioni dovute a cotture meno delicate. In aggiunta, tutte queste caratteristiche aumentano la <b>digeribilità dei prodotti cucinati</b> che avranno anche meno grassi grazie al ridotto apporto di condimento rispetto alla cottura tradizionale.
					</p>

					<!-- Slider utilizzo forno a vapore -->

					<slick>
						<template slot="slides">
							<div class='recipe'>
								<img :src="require('../../assets/img/campaigns/electrolux/01.jpg')">
								<div class="recipe-name small">
									Prima di qualsiasi cottura con il forno a vapore, ricordati di aggiungere acqua nell’apposito contenitore. Non è necessario avere dosi precise, il forno ti avviserà quando sarà necessario aggiungerne altra.
								</div>
							</div>
							<div class='recipe'>
								<img :src="require('../../assets/img/campaigns/electrolux/02.jpg')">
								<div class="recipe-name small">
									La sonda per alimenti consente di cuocere con più precisione carni e pesci, misurandone la temperatura al cuore e determinando così il grado di cottura desiderato.
								</div>
							</div>
							<div class='recipe'>
								<img :src="require('../../assets/img/campaigns/electrolux/04.jpg')">
								<div class="recipe-name small">
									Se hai un forno con il sondino in dotazione, puoi impostare queste informazioni direttamente dal display del forno.
								</div>
							</div>
							<div class='recipe'>
								<img :src="require('../../assets/img/campaigns/electrolux/03.jpg')">
								<div class="recipe-name small">
									Con la cottura combinata a vapore il pesce si mantiene morbido e non perde nessuna delle sue proprietà organolettiche.
								</div>
							</div>
							
						</template>
					</slick>
			
					<h2>
						Cottura più rapida e sostenibile
					</h2>

					<p>
						Ecco altri due aspetti correlati a questo tipo di cottura. Il vapore ha un calore più penetrante che consente di ridurre i tempi di cottura. In aggiunta, non dovrete più aprire con frequenza il forno per controllare che l’arrosto non si stia seccando, dunque <b>meno dispersione di calore e meno consumo energetico</b>. 
						<br>
						In più sarà possibile recuperare piatti ed alimenti che richiedono una bella riscaldata senza la preoccupazione di ritrovarli asciutti e duri. L’aria calda umida renderà infatti appetitoso anche il pane indurito o il piatto del giorno prima: un bell’aiuto per <b>ridurre lo spreco di cibo</b> nella vita di tutti i giorni.
					</p>

					<h2>
						Con Electrolux e Quomi, la tua cena è già in forno
					</h2>

					<p>
						Scopri la promozione “Il Vapore premia ogni piatto”. <b>Dal 1 Settembre all'11 Novembre 2019</b>, se acquisti un <b>Forno a Vapore Electrolux</b> tra i modelli in promozione, riceverai in regalo una <b>Gift Card Quomi</b>, valida per l’attivazione di un piano a scelta per ricevere a casa tua le Food Box. Il modo migliore per iniziare a scoprire tutti i vantaggi della cucina <b>con il tuo nuovo forno a vapore</b>.
					</p>

					<p>
						<a href="https://www.electrolux.it/local/ilvaporepremiaognipiatto/"
	                  		target="_blank"
	                	>
							<img :src="require('../../assets/img/campaigns/electrolux/banner.jpg')">
						</a>
					</p>
<!-- 					<p>
						<a href="https://www.electrolux.it/local/ilvaporepremiaognipiatto/"
	                    	class="flex flex-center"
	                    	target="_blank"
	                	>
	                    	<CTA
	                        	:content="`Scopri di più`"
	                    	/>
	                	</a>
	                </p> -->
					
					<h2>
						Prova la cottura a vapore per le tue ricette
					</h2>

					<p>
						Scopri le <b>ricette pensate da Quomi insieme ad Electrolux per il forno a vapore</b>. Ogni settimana potrai trovare una novità da introdurre nella tua cucina e sperimentare gusti e sapori cotti in maniera perfetta.
					</p>
					<!-- Slider ricette con titoli -->
					<slick>
						<template slot="slides">
							<div class='recipe' v-for="(item, index) in recipes" :key="index">
								<a :href="'/ricetta/' + item.url"><img :src="item.images.big" :alt='item.title'></a>
								<div class="recipe-name">{{ item.title }}</div>
							</div>
						</template>
					</slick>
				</section>

				<router-link
                    :to="{ name: 'flow-subscribed' }"
                    class="flex flex-center"
                >
                    <CTA
                        :content="`Vai alle ricette`"
                    />
                </router-link>	
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import TriangleImage from '../TriangleImage'
	import Slick from '../Slick'
	import { goSlick } from '../../assets/js/slick'

	import { RecipeApi } from '../../api/RecipeApi'
	import { Recipe } from '../../core/Recipe'

	export default {
	components: {
		TriangleImage,
		Slick
	},

	data () {
		return {
			recipes: null,
			loading: true
		}
	},

	computed: {
		recipesId () {
			if (process.env.NODE_ENV === 'development') {
				return [1,2,3,4]
			}

			return [783, 782, 781, 780, 779, 778, 777, 776]
		}
	},

	methods: {
		load () {
			var promises = []

			this.recipesId.forEach(id => {
				promises.push(new Promise((resolve, reject) =>
					this.loadRecipe(id).then(_ => {
						resolve(_)
					})
				))
			})

			return Promise.all(promises)
		},

		loadRecipe (id) {
			this.recipes = []
			var rm = new RecipeApi()
			return rm.recipe(id)

			.then(response => {
				var recipe = new Recipe(response.body.data.resource)
				this.recipes.push(recipe)
			})
		}
	},

	mounted () {
		this.load().then(_ => {
			this.loading = false
			goSlick()
		})
	}

}
</script>

<style scoped>

.slick-slide >>> .recipe-name.small {
	font-size: 12px;
	text-align: left;
	min-height: 55px;
}

.triangle-image {
	background: url("../../assets/img/covers/electrolux.jpg");
	background-position: center 20%;
	background-repeat: no-repeat;
	background-size: cover;
}


.content {
	max-width: 800px;
}

.paragraph p {
  margin-bottom: 45px;
}

@media (max-width: 1024px) {
	.triangle-image >>> h1 {
		font-size: 30px;
	}
}

</style>
